import { TextField } from "@mui/material";
import MDTypography from "components/MDTypography";
import { useField } from "formik";
import TextError from "utils/TextError";

const FormTextField = ({ label, hideError, ...props }) => {
  const [field, meta] = useField(props);

  return (
    <>
      <MDTypography variant="h6" color="inherit" style={{ marginBottom: 4 }}>
        {label}{" "}
        {props.notRequired ? "" : <span style={{ color: "red" }}>*</span>}
      </MDTypography>
      <TextField
        className="contact"
        fullWidth
        {...field}
        {...props}
        error={meta.touched && Boolean(meta.error)}
      />
      {/* Render error only if hideError is NOT true */}
      {!hideError && meta.touched && meta.error && (
        <TextError msg={meta.error} />
      )}
    </>
  );
};

export default FormTextField;
